import MotorTermsAndConditionsPage from './MotorTermsAndConditionsPage';

export default MotorTermsAndConditionsPage;
